import BarnSheetsReports from './BarnSheetsReports';

export default BarnSheetsReports;
